import { render, staticRenderFns } from "./PassengerFlowMonth.vue?vue&type=template&id=1226c7c6&scoped=true&"
import script from "./PassengerFlowMonth.vue?vue&type=script&lang=js&"
export * from "./PassengerFlowMonth.vue?vue&type=script&lang=js&"
import style0 from "./PassengerFlowMonth.vue?vue&type=style&index=0&id=1226c7c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1226c7c6",
  null
  
)

export default component.exports